export class FaqMaster {
    public faqMasterId:number;
    public heading:string;
    public description:string;
} 